var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyCartSm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 147,
    viewBox: "0 0 150 147",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_16)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 147,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.2195 113.021C66.2195 113.021 71.8953 82.1884 41.964 65.6829C12.0326 49.1775 10.6258 49.3711 4.70744 47.4834C1.31167 46.3217 -2.18113 48.7419 1.74827 53.679C5.67767 58.6161 3.44616 59.8746 11.305 62.0527C19.1637 64.2308 20.3765 73.8146 24.3059 76.1864C28.2353 78.5581 31.6796 79.1874 43.7104 84.3665C54.6254 89.0616 63.9395 102.324 63.9395 107.019C63.9395 111.714 74.6119 113.263 74.6119 113.263L66.2195 113.021Z",
    fill: "url(#paint0_linear_4_16)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1522 108.713C65.1522 108.713 72.7685 80.349 46.5725 65.0053C20.3765 49.6615 11.2079 49.8551 6.01723 48.0158C3.05805 46.9509 11.2079 50.6296 14.6037 55.1795C17.9995 59.7293 17.1748 58.7129 23.3357 62.1011C30.4668 66.0217 33.426 69.8456 37.5979 70.62C43.6618 71.7817 41.8669 78.0741 52.3938 82.8176C61.902 87.1255 63.1148 98.6454 63.1148 103.002C63.1148 107.358 72.4289 108.81 72.4289 108.81L65.1522 108.713Z",
    fill: "url(#paint1_linear_4_16)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.5423 104.551L94.5015 101.743C95.9083 100.436 97.6547 99.4682 99.5466 98.9842C108.812 96.564 137.919 87.4643 149.998 65.4893C150.095 65.2957 149.998 65.0537 149.804 64.9569H149.756C149.707 64.9569 149.659 64.9085 149.61 64.9085C145.584 64.618 124.869 64.2792 97.1696 87.8515C96.6845 88.2387 96.1993 88.7227 95.8113 89.2068C95.1321 90.1748 93.9678 91.8205 93.4342 92.6918C92.7066 93.9503 94.1619 96.08 92.2214 97.9677C90.281 99.8554 86.109 104.551 86.109 104.551L89.5048 107.067L91.5423 104.551Z",
    fill: "url(#paint2_linear_4_16)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7762 102.711C75.7762 102.711 83.732 31.7524 62.0475 9.43857C42.061 -11.0843 41.7699 7.79286 41.8184 10.9875C41.8184 11.2779 41.9154 11.5199 42.0125 11.7619C46.718 20.5229 48.3674 30.6391 46.6695 40.4165C44.6321 50.6779 59.3309 49.3227 60.5922 59.4389C61.8535 69.5551 66.9957 85.1409 66.462 92.3046C65.9284 99.4682 65.8799 106.438 65.8799 106.438L73.8842 106.68L75.7762 102.711Z",
    fill: "url(#paint3_linear_4_16)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.6792 102.953C75.7277 102.808 75.7762 102.614 75.8247 102.469C76.3098 97.8225 83.0043 30.9779 62.0476 9.43859C42.2065 -10.9875 41.9155 7.50247 42.0125 10.8423C42.061 11.2295 42.255 11.6167 42.4491 11.9555C43.9044 14.0853 50.4534 23.3787 56.2747 22.3138C72.3319 19.458 58.1667 38.7224 66.8987 49.0323C73.8843 57.164 71.5557 85.2377 71.0221 92.4498C70.6825 96.5156 70.0034 100.485 68.9846 104.454C68.7906 105.47 69.4698 106.438 70.44 106.632C70.4885 106.632 70.537 106.632 70.5855 106.632C70.731 106.632 70.8281 106.68 70.9736 106.68H72.4289C73.3021 106.729 74.0783 106.293 74.4664 105.519L75.6792 102.953Z",
    fill: "url(#paint4_linear_4_16)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.4895 107.067C83.4895 107.067 84.8963 87.4159 96.3934 75.4119C99.5951 72.1205 103.67 69.8456 108.133 68.8291C111.577 68.0546 117.205 65.2957 122.104 56.0991C122.104 56.0991 131.37 43.0303 140.636 39.0612C149.901 35.0922 140.636 34.6082 140.636 34.6082C140.636 34.6082 114.148 39.6421 97.1696 55.131C96.1023 56.0991 94.9866 57.0188 93.7738 57.7932C89.3593 60.7942 77.183 72.1205 77.7166 105.18L83.4895 107.067Z",
    fill: "url(#paint5_linear_4_16)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.484 105.47C106.484 105.47 106.872 103.098 103.719 103.147C100.953 103.244 54.1887 102.905 54.1887 102.905C54.1887 102.905 52.0058 102.905 52.1513 104.551C52.2968 106.196 59.3794 145.064 60.0586 145.887C60.3497 146.371 60.8348 146.758 61.4169 146.903C62.2901 147.145 95.1321 146.952 95.1321 146.952C95.9083 146.855 96.4904 146.226 96.5389 145.451C96.4904 145.5 106.581 105.954 106.484 105.47Z",
    fill: "#9A9DF6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4_16",
    x1: 0.00841742,
    y1: 80.1843,
    x2: 74.6022,
    y2: 80.1843,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#93FD93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#21C2C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#84F599"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4_16",
    x1: 27.9565,
    y1: 56.7262,
    x2: 70.2321,
    y2: 108.673,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#93FD93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#21C2C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#84F599"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4_16",
    x1: 76.7873,
    y1: 115.376,
    x2: 134.966,
    y2: 70.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#93FD93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#21C2C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#84F599"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4_16",
    x1: 91.4324,
    y1: 92.5006,
    x2: 41.5161,
    y2: 29.1683,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#93FD93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#21C2C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#84F599"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4_16",
    x1: 42.0067,
    y1: 53.326,
    x2: 77.2251,
    y2: 53.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#93FD93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#21C2C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#84F599"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4_16",
    x1: 74.1834,
    y1: 110.726,
    x2: 112.218,
    y2: 55.5979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#93FD93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#21C2C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#84F599"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_16"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 147,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyCartSm);
export default __webpack_public_path__ + "static/media/empty-cart-sm.999dc7fac8f8dbf839ab90e847942ce5.svg";
export { ForwardRef as ReactComponent };